<template>
  <form-wrapper title="Decorative Elements Settings">
    <background-color-settings
      :settings.sync="settings.primaryAccentBackground"
      title="Primary Accent Background"
    />

    <background-color-settings
      :settings.sync="settings.secondAccentBackground"
      title="Second Accent Background"
    />

    <background-color-settings
      :settings.sync="settings.thirdAccentBackground"
      title="Third Accent Background"
    />

    <color-settings
      title="Primary Aside Elements Color"
      button-title="Separator Color"
      :color.sync="settings.primarySeparatorColor"
    />

    <color-settings
      title="Second Aside Elements Color"
      button-title="Separator Color"
      :color.sync="settings.secondSeparatorColor"
    />
    <!-- dfs -->
    <color-settings
      title="Primary Accent Color"
      button-title="Accent Color"
      :color.sync="settings.primaryAccentColor"
    />

    <color-settings
      title="Second Accent Color"
      button-title="Accent Color"
      :color.sync="settings.secondAccentColor"
    />

    <color-settings
      title="Third Accent Color"
      button-title="Accent Color"
      :color.sync="settings.thirdAccentColor"
    />

    <color-settings
      title="Fourth Accent Color"
      button-title="Accent Color"
      :color.sync="settings.fourthAccentColor"
    />

    <color-settings
      title="Fifth Accent Color"
      button-title="Accent Color"
      :color.sync="settings.fifthAccentColor"
    />

    <reset-submit
      @submit="generateSubmit('decorativeElement')"
      @reset="resetSettings"
    />

  </form-wrapper>

</template>

<script>
  import { validationSubmitFunc } from '@/utils/mixins'
  import BackgroundColorSettings from './../styleSettingsFormComponents/BackgroundColorSettings'
  import ColorSettings from './../styleSettingsFormComponents/ColorSettings'
  import FormWrapper from './FormWrapper'
  import ResetSubmit from './../styleSettingsFormComponents/ResetSubmit'
  import { submitGlobalStyles } from '@/utils/mixins'

  import {
    generateDefaultBackgroundParams,
    generateDefaultColor,
    generateMapState
  } from './utils'

  export default {
    name: 'ButtonSettings',
    components: {
      BackgroundColorSettings,
      ColorSettings,
      FormWrapper,
      ResetSubmit
    },
    mixins: [submitGlobalStyles],
    data () {
      return {
        settings: {
          primaryAccentBackground: generateDefaultBackgroundParams(),
          secondAccentBackground: generateDefaultBackgroundParams(),
          thirdAccentBackground: generateDefaultBackgroundParams(),
          primarySeparatorColor: generateDefaultColor(),
          secondSeparatorColor: generateDefaultColor(),

          primaryAccentColor: generateDefaultColor(),
          secondAccentColor: generateDefaultColor(),
          thirdAccentColor: generateDefaultColor(),
          fourthAccentColor: generateDefaultColor(),
          fifthAccentColor: generateDefaultColor(),
        }
      }
    },
    computed: {
      ...generateMapState('decorativeElement')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/pages/GeneralSettings/StylesSettings/styleForms/DecorativeElemntsSettings.vue